import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { RoleTypeStrategy } from '../../global/strategies/user_mode_api_strategy';

export interface ICourseGroup {
  course_group: string;
  id: number;
  program_slot: number;
  term: number;
}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'saveCourseGroupToTermCommand',
    function saveCourseGroupToTermCommand(
      $state: ng.ui.IStateService,
      advisorSaveCourseGroupToTermCommand: ICommand,
      studentSaveCourseGroupToTermCommand: ICommand,
      defineCommand: IDefineCommand
    ): ICommand {
      return defineCommand(
        'saveCourseGroupToTermCommand',
        (deferred: ng.IDeferred<IQuery[]>, course: ICourseGroup): void => {
          const roleType = RoleTypeStrategy.evaluate($state);
          if (roleType === 'student') {
            studentSaveCourseGroupToTermCommand(course.term, course, course.program_slot).then(deferred.resolve);
          } else if (roleType === 'advisor') {
            advisorSaveCourseGroupToTermCommand(course.term, course).then(deferred.resolve);
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/save_course_group_to_term_command.ts